import { Typography } from "@mui/material";

import HNSColors from "../../../../../../ui library/HNSColors";

export default function Chip({ label }) {
  return (
    <div
      className="max-w-full px-2 py-1"
      style={{ backgroundColor: HNSColors.secondary[900], borderRadius: "500px" }}
    >
      <Typography
        className="break-words text-center text-[14px] font-normal"
        style={{ color: HNSColors.secondary[400] }}
      >
        {label}
      </Typography>
    </div>
  );
}
